// Import Swiper and modules
import Swiper, { Navigation, Pagination } from "swiper";

export const socials = () => {
  const $socialsSections = document.querySelectorAll("section.socials");
  if ($socialsSections) {
    $socialsSections.forEach(($socials) => {
      const $socialsNav = $socials.querySelector(".socials__nav");

      const $socialsSwiper = $socials.querySelector(
        ".socials__swiper-container .socials__swiper.swiper"
      );

      if ($socialsSwiper) {
        const maxSlides = parseInt($socialsSwiper.dataset.maxSlides);
        const swiperConfig = {
          modules: [Navigation, Pagination],
          direction: "horizontal",
          speed: 1000,
          // autoplay: {
          //   delay: 5000,
          // },
          // pagination: {
          //   bulletActiveClass: "socials__swiper-bullet--active",
          //   bulletClass: "socials__swiper-bullet",
          //   bulletElement: "button",
          //   el: ".socials__swiper-pagination",
          //   modifierClass: "socials__swiper-pagination--",
          //   type: "bullets",
          //   clickable: true,
          // },
          slidesPerView: 2,
          spaceBetween: 12,
          breakpoints: {
            768: {
              slidesPerView: 3,
              spaceBetween: 16,
            },
            1024: {
              slidesPerView: maxSlides,
              spaceBetween: 32,
            },
          },
        };
        if ($socialsNav) {
          const $socialsNavButtonPrev = $socialsNav.querySelector(
            ".socials__nav-button.socials__nav-button--prev"
          );
          const $socialsNavButtonNext = $socialsNav.querySelector(
            ".socials__nav-button.socials__nav-button--next"
          );
          swiperConfig.navigation = {
            disabledClass: "socials__nav-button--disabled",
            nextEl: $socialsNavButtonNext,
            prevEl: $socialsNavButtonPrev,
          };
        }
        const swiperObject = new Swiper($socialsSwiper, swiperConfig);
      }
    });
  }
};

export default socials;
